import React, { useState } from "react";
import AppContainer from "../../../components/AppContainer";
import {
  Avatar,
  Box,
  Container,
  Divider,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import { allImages, appLogo } from "../../../assets";
import { getGradeAndRemarks } from "../../../utils";

const data = [
  {
    subject: "English",
    totalMarks: 80,
    obtainMarks: 0,
    passingMarks: 40,
    remarks: "",
    grade: "",
  },
  {
    subject: "Math",
    totalMarks: 80,
    obtainMarks: 0,
    passingMarks: 40,
    remarks: "",
    grade: "",
  },
  {
    subject: "Science",
    totalMarks: 80,
    obtainMarks: 0,
    passingMarks: 40,
    remarks: "",
    grade: "",
  },
  {
    subject: "Chemistry",
    totalMarks: 80,
    obtainMarks: 0,
    passingMarks: 40,
    remarks: "",
    grade: "",
  },
  {
    subject: "Biology",
    totalMarks: 80,
    obtainMarks: 0,
    passingMarks: 40,
    remarks: "",
    grade: "",
  },
];

const FixedStudentStates = ({ field, value }) => {
  return (
    <Stack direction={"row"} alignItems={"center"} spacing={2}>
      <Typography variant="body1" fontWeight={500}>
        {field}
      </Typography>

      <Typography variant="body1" borderBottom={"1px solid black"}>
        {value}
      </Typography>
    </Stack>
  );
};

const HeadingBox = ({ boxWidth, boxValue }) => {
  return (
    <Stack
      p={1.5}
      bgcolor={"#343A40"}
      justifyContent={"center"}
      alignItems={"center"}
      width={boxWidth}
      borderRadius={1.5}
    >
      <Typography fontSize={"1.225ren"} fontWeight={400} color={"custom.white"}>
        {boxValue}
      </Typography>
    </Stack>
  );
};

const TableCell = ({ width, children }) => {
  return (
    <Box p={1} width={width} border={"1px solid #343A40"}>
      {children}
    </Box>
  );
};

const ReportCardTemplate = () => {
  const [dumyData, setDumyData] = useState(data);

  const handleEditMarks = (e, val, index) => {
    const value = parseInt(e);

    if (value > val.totalMarks) {
      alert(`Obtained marks cannot exceed total marks (${val.totalMarks})!`);
      return;
    }

    let tempArray = [...dumyData];
    let performance = getGradeAndRemarks(value);

    tempArray[index].obtainMarks = value;
    tempArray[index].grade = performance.grade;
    tempArray[index].remarks = performance.remarks;
    setDumyData(tempArray);
  };

  const totalMarks = (params) => {
    return params.reduce(
      (acc, curr) => {
        return {
          total: acc.total + curr.totalMarks, // add total marks
          passing: acc.passing + curr.passingMarks, // add passing marks
          obtained: acc.obtained + curr.obtainMarks, // add obtained marks
        };
      },
      { total: 0, passing: 0, obtained: 0 } // initial value
    );
  };

  const totalMarksResult = totalMarks(dumyData);

  return (
    <AppContainer
      primaryHeading={"Report Card Template"}
      secondaryHeading={"Edit Student report"}
    >
      <Container maxWidth={"md"}>
        <Stack
          direction={"row"}
          alignItems={"center"}
          justifyContent={"center"}
          gap={1}
          mt={3}
          mb={2}
        >
          <Avatar
            src={appLogo.schoologo}
            sx={{
              height: 150,
              width: 150,
            }}
          />
          <Typography variant="h3" fontWeight={600} color={"primary.main"}>
            Report Card
          </Typography>
        </Stack>

        <Box>
          <Stack
            direction={"row"}
            alignItems={"center"}
            justifyContent={"space-between"}
            my={1.5}
          >
            <FixedStudentStates field={"Student Name"} value={"Sumbul Anwar"} />
            <FixedStudentStates field={"Section"} value={"Section A"} />
          </Stack>

          <Stack
            width={"100%"}
            mt={3}
            mb={1}
            direction={"row"}
            alignItems={"center"}
            gap={1}
          >
            <HeadingBox boxValue={"Subjects"} boxWidth={"30%"} />
            <HeadingBox boxValue={"Credit Earn"} boxWidth={"20%"} />
            <HeadingBox boxValue={"Grades"} boxWidth={"20%"} />
            <HeadingBox boxValue={"Remarks"} boxWidth={"30%"} />
          </Stack>

          {/* //row */}

          {dumyData.map((val, index) => {
            return (
              <Stack width={"100%"} gap={1} direction={"row"}>
                <TableCell width={"30%"}>
                  <Stack direction={"row"} justifyContent={"space-between"}>
                    <Typography fontWeight={500}>{val.subject}</Typography>
                    <Typography>{val.totalMarks}</Typography>
                  </Stack>
                </TableCell>
                {/* <TableCell width={"20%"}> */}
                <input
                  type={"number"}
                  value={val.obtainMarks}
                  onChange={(e) => handleEditMarks(e.target.value, val, index)}
                  style={{
                    width: "20%",
                    textAlign: "center",
                    border: "1px solid #343A40",
                    fontSize: "1rem",
                  }}
                />

                <TableCell width={"20%"}>
                  <Typography textAlign={"center"}>{val.grade}</Typography>
                </TableCell>
                <TableCell width={"30%"}>
                  <Typography textAlign={"center"}>{val.remarks}</Typography>
                </TableCell>
              </Stack>
            );
          })}
          <Divider
            sx={{
              margin: "10px 0",
              borderBottomWidth: "thick",
              borderColor: "#343A40",
            }}
          />

          <Stack
            width={"100%"}
            mt={3}
            mb={1}
            direction={"row"}
            alignItems={"center"}
            gap={1}
          >
            <HeadingBox boxValue={"Result"} boxWidth={"50%"} />
            <HeadingBox boxValue={"Percentage"} boxWidth={"50%"} />
          </Stack>

          <Stack width={"100%"} gap={1} direction={"row"} my={0.5}>
            <TableCell width={"50%"}>
              <Typography>
                <b>Total Subject Marks</b> : {totalMarksResult.total}
              </Typography>
              <Typography>
                <b>Total Passing Marks </b>: {totalMarksResult.passing}
              </Typography>
              <Typography>
                <b>Total Obtain Marks</b> :{" "}
                {isNaN(totalMarksResult.obtained)
                  ? 0
                  : totalMarksResult.obtained}
              </Typography>
            </TableCell>
            <TableCell width={"50%"}>
              <Typography>
                <b>First Term</b> : 95%
              </Typography>
              <Typography>
                <b>Second term </b>: 100%
              </Typography>
              <Typography>
                <b>Third Term</b> 50%
              </Typography>
            </TableCell>
          </Stack>
          <Stack width={"100%"} gap={1} direction={"row"} my={0.5}>
            <TableCell width={"50%"}>
              <Box display="flex" flexWrap="wrap">
                <Typography width="33.33%">
                  <b>A+</b> = 100 - 90
                </Typography>
                <Typography width="33.33%">
                  <b>A</b> = 89 - 80
                </Typography>
                <Typography width="33.33%">
                  <b>B</b> = 79 - 70
                </Typography>
                <Typography width="33.33%">
                  <b>C</b> = 69 - 60
                </Typography>
                <Typography width="33.33%">
                  <b>D</b> = 59 - 50
                </Typography>
                <Typography width="33.33%">
                  <b>F</b> = 49 or below
                </Typography>
              </Box>
            </TableCell>
            <TableCell width={"50%"}>
              <Stack alignItems={"center"} justifyContent={"center"}>
                <Typography>Teacher Signature</Typography>
                <img src={allImages.teacherSignature} width={150} />
              </Stack>
            </TableCell>
          </Stack>
        </Box>
      </Container>
    </AppContainer>
  );
};

export default ReportCardTemplate;
